// extracted by mini-css-extract-plugin
export var addOnContainer = "add-on-module--addOnContainer--d83aa";
export var addOnCopyRow = "add-on-module--addOnCopyRow--1cf37";
export var addOnDark = "add-on-module--addOnDark--696a6";
export var addOnHeadRow = "add-on-module--addOnHeadRow--bf60b";
export var addOnHeading = "add-on-module--addOnHeading--7a1ee";
export var addOnIcon = "add-on-module--addOnIcon--fe89b";
export var addOnIconCol = "add-on-module--addOnIconCol--3fb15";
export var addOnLight = "add-on-module--addOnLight--436f0";